export default __webpack_public_path__ + "static/media/Fixel_Logo2019vector1.4b7dbb92.svg";